import axios from 'axios';
import { map, sortBy } from 'lodash';

import config from 'inventory-listing/config';

export function fetchMakePriorities(organizationUnitId) {
    const requestConfig = {
        method: 'get',
        url: `${config.endpoint.widget}/widgets/listing/makePriorities`,
        headers: { 'Content-Type': 'application/json' },
        params: { organizationUnitId },
    };
    return axios(requestConfig).then(({ data }) => data);
}

/**
 * map the catalog API format of make priorities as VehicleOrder format (usable by webauto supplier API)
 * @param makePriorities with at least a make id
 * @returns {Array}
 */
export function mapMakePrioritiesAsVehicleOrders(makePriorities) {
    const orderedMakePriorities = sortBy(makePriorities, ['priority', 'name']);
    return map(orderedMakePriorities, (makePriority) => ({
        value: makePriority.id,
        vehicleOrderField: 'CATALOG_MAKE_ID',
    }));
}

export default {
    fetchMakePriorities,
    mapMakePrioritiesAsVehicleOrders,
};
